import store from "@/store";
import Budget from '@/components/game/scenes/Budget';
import StatusMeters from '@/components/game/sidebar/StatusMeters';

export default [
	{
		path: 'step/:index(\\d+)',
		components: {
			gameSpace: Budget,
			sidebar: StatusMeters,
		},
		async beforeEnter(to, from, next) {
			// function duplicated in Tutorial.vue for updating routes
			await store.dispatch("tutorial/steps/activate", { index: parseInt(to.params.index) });
			next();
		},
	},
	{
		path: 'step/complete',
		beforeEnter(to, from, next) {
			const path = store.getters["tutorial/steps/hasNextStep"] ? "/tutorial/step/next" : "/tutorial/complete";
			next({ path });
		},
	},
	{
		path: 'step/next',
		beforeEnter(to, from, next) {
			const index = store.getters["tutorial/steps/nextIndex"];
			next({ path: `/tutorial/step/${index}` });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/tutorial-steps.routes.js